import {
  UpdateCommissionFeeRequestDto,
  UpdateCommissionFeeResponseDto,
  UpdateUserDetailsRequestDto,
  UpdateUserDetailsResponseDto,
} from '@sparling/financial-common'
import axios, { AxiosRequestConfig } from 'axios'

export const updateUserCommissionFee = async (
  { token, idSf, ...data }: { idSf: string } & UpdateCommissionFeeRequestDto & { token: string },
  options: AxiosRequestConfig = {},
): Promise<UpdateCommissionFeeResponseDto> => {
  const response = await axios.post<UpdateCommissionFeeResponseDto>(
    `${process.env.REACT_APP_SERVER_URL}/crm/user/${idSf}/update-commission-fee`,
    data,
    {
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
        ...options.headers,
      },
      ...options,
    },
  )
  return response.data
}

export const updateUserDetails = async (
  { token, idSf, ...data }: { idSf: string } & UpdateUserDetailsRequestDto & { token: string },
  options: AxiosRequestConfig = {},
): Promise<UpdateUserDetailsResponseDto> => {
  const response = await axios.post<UpdateUserDetailsResponseDto>(
    `${process.env.REACT_APP_SERVER_URL}/crm/user/${idSf}/update-user-details`,
    data,
    {
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
        ...options.headers,
      },
      ...options,
    },
  )
  return response.data
}
